import store from '@/store'
import i18n from '../../lang'
import { router } from '@/router'
import { mapActions } from 'vuex'
import { hubListFromEntity, createHub, updateHub, deleteHub, availableServicesForHub } from '@/backend/hubs'

const state = {
  hubList: [],
  availableServices: []
}

export const mutations = {
  SET_HUB_LIST: (state, { hubList }) => {
    state.hubList = hubList
  },
  SET_AVAILABLE_SERVICE_LIST: (state, { availableServices }) => {
    state.availableServices = availableServices
  }
};

export const actions = {
  ...mapActions({
    enableMessage: 'message/enable'
  }),

  loadList({ commit }, entityId) {
    return hubListFromEntity(entityId)
    .then((response) => {
      let hubList = response.data
      commit('SET_HUB_LIST', { hubList: hubList })
      hubList.length === 0 ? store.dispatch('noData/enable') : store.dispatch('noData/disable')
    })
    .catch((error) => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  create({ commit, dispatch }, hubParams) {
    return new Promise((resolve, reject) => {
      createHub(hubParams)
      .then((response) => {
        dispatch('loadList', hubParams.entity_id)
        let message = {
          type: 'success',
          content: i18n.t(
            'messages.create_success', {
              'resource': i18n.t('resources.hub'),
              'name': hubParams.name
            }
          )
        }
        dispatch('message/enable', message, { root: true })

        resolve(response.data)
      })
      .catch(error => {
        dispatch('message/enable', { type: 'danger', content: error.response.data.error }, { root: true })

        reject(error.response)
      })
    })
  },

  delete({ commit, dispatch }, hubParams) {
    return deleteHub(hubParams.id)
    .then((response) => {
      let message = {
        type: 'success',
        content: i18n.t(
          'messages.delete_success', {
            'resource': i18n.t('resources.hub'),
            'name': hubParams.name
          }
        )
      }
      dispatch('message/enable', message, { root: true })
    })
    .catch((error) => {
      dispatch('message/enable', { type: 'danger', content: error.response.data.error }, { root: true })
    })
  },

  update({ commit, dispatch }, hubParams) {
    return updateHub(hubParams)
    .then((response) => {
      let message = {
        type: 'success',
        content: i18n.t(
          'messages.update_success', {
            'resource': i18n.t('resources.hub'),
            'name': hubParams.name
          }
        )
      }
      dispatch('message/enable', message, { root: true })
      return true
    })
    .catch(error => {
      dispatch('message/enable', { type: 'danger', content: error.response.data.error }, { root: true })
      return false
    })
  },

  loadAvailableServicesForHub({ commit }, hub_id) {
    return availableServicesForHub(hub_id)
    .then((response) => {
      let availableServices = response.data
      commit('SET_AVAILABLE_SERVICE_LIST', { availableServices: availableServices })
    })
    .catch((error) => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  }
};

export const getters = {
  hubList: state => state.hubList,
  availableServices: state => state.availableServices
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/hubs.js